export default class Expense {
    constructor() {
        this.id = "";
        this.recipient = { id: "", content: "" };
        this.description = "";
        this.document = "";
        this.value = 0;
        this.dueDate = "";
        this.competenceDate = "";
        this.typePayment = { id: "", content: "" };
        this.observation = "";
        this.rentId = "";
    }
    update(data) {
        this.id = data.id;
        this.type = data.type;
        this.recipient = { id: data.recipient.id, content: data.recipient.content };
        this.description = data.description;
        this.document = data.document;
        this.value = data.value;
        this.dueDate = data.dueDate;
        this.competenceDate = data.competenceDate;

        if (data.typePayment.id)
            this.typePayment = { id: data.typePayment.id, content: data.typePayment.content };

        this.observation = data.observation;
    }
}